import ManagedAccordionSection from "@eisinc/MobiusOverrides/AccordionSection";

export default ManagedAccordionSection;

export * from "@eisinc/MobiusOverrides/AccordionSection";
